module.exports = __webpack_public_path__ + "static/media/wheelchair.21338ac2.svg";